import React, { Component } from 'react'
import DocsModel from '../models/DocsModel'
import { Upload, message, Icon, Button, Alert } from 'antd'

class DocsUpload extends Component {

    constructor(props) {
        super(props)

        const uploadOptions = DocsModel.getOptions()
        this.count = 0;
        var attachment, hideMessage = {}, me = this;
        this.uploadOptions = {
            name: 'file',
            action: DocsModel.endpoint() + '/upload',
            //listType: 'picture',
            defaultFileList: [],
            className: 'upload-list-inline',
            headers: uploadOptions.headers,
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    //console.log(info.file, info.fileList)
                }
                if (info.file.status === 'done') {
                    hideMessage[info.file.name]()
                    if (info.file.response.status === 'success') {
                        message.success(`${info.file.name} foi carregado.`)
                        attachment = {
                            uid: info.file.uid,
                            name: info.file.name
                        }
                        me.count++;
                        me.props.onUploadSuccess(attachment)
                    } else {
                        message.error(`${info.file.name} falhou: ${info.file.response.error}`)
                    }
                } else if (info.file.status === 'error') {
                    hideMessage[info.file.name]()
                    if (info.file.response) {
                        message.error(`${info.file.name} falhou: ${info.file.response.error}`)
                    } else {
                        message.error(`${info.file.name} falha de comunicação.`)
                    }
                }
            },
            beforeUpload(file) {
                const maxSize = parseInt(DocsModel.getMaxUploadSize() / 1000000, 10)
                if (file.size > DocsModel.getMaxUploadSize()) {
                    message.error(`Erro: ${file.name} excede ${maxSize} MBs`)
                    return false
                }
                hideMessage[file.name] = message.loading('Aguarde. O carregamento pode demorar...', 300);
                return true
            },
            onRemove(file) {
                me.count--
                me.props.onRemoveUpload(file.name)
                return true
            }
        }
    }

    render() {
        const maxUploadSize = parseInt(DocsModel.getMaxUploadSize() / 1000000, 10);
        return (
            <div>
                { !!this.count ? (<Alert message="ATENÇÃO: apenas 1 ficheiro por registo" type="warning" showIcon />) : null }
                <Upload {...this.uploadOptions} id="upload" disabled={!!this.count}>
                    <Button>
                        <Icon type="upload" /> Escolher ficheiro
                    </Button>
                </Upload>
                <p>Tipos permitidos: pdf e zip</p>
                <p>Limite de tamanho de cada ficheiro a carregar: {maxUploadSize} MBytes</p>
            </div>
        )
    }
}

export default DocsUpload;



// WEBPACK FOOTER //
// ./src/components/DocsUpload.js